import React from 'react';

import { Badge } from '@components/badge/Badge';

import styles from './filter-toggle.module.scss';

interface FilterToggleProps {
	name: string;
	id: string;
	value?: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	checked?: boolean;
	defaultChecked?: boolean;
	isRounded?: boolean;
	children?: React.ReactNode;
}

export const FilterToggle = ({
	children,
	name,
	id,
	value,
	checked,
	defaultChecked,
	onChange,
	isRounded,
}: FilterToggleProps) => {
	return (
		<div className={styles['filter-toggle']}>
			<input
				checked={checked}
				className="sr-only"
				defaultChecked={defaultChecked}
				id={id}
				name={name}
				onChange={onChange}
				type="radio"
				value={value}
			/>
			<Badge
				className={styles['filter-toggle__label']}
				htmlFor={id}
				isRounded={isRounded}
				tag="label"
			>
				{children}
			</Badge>
		</div>
	);
};
